var {AmpersandCollection} = require('catalog/libs');

var HPEServices = require('../../../base/hpe.services');
var HPEConstants = require('../../../base/hpe.constants');
var ProductModel = require('../../../base/hpe.product.model');

/**
 * Product Catalog Model for each Compare Tray Item
 */
var CompareTrayItemModel = ProductModel.ProductBaseModel.extend({

    props: {
        active: ['boolean', false, false],
        removed: ['boolean', false, false],
        added: ['boolean', false, false],
        isRemoveInProcess: ['boolean', false, false],
        i18n: 'object'
    },

    /**
     * remove this model from tray/collection
     */
    remove: function() {
        HPEServices.publish(HPEConstants.catalog.COMPARE_TRAY_REMOVE_COMPLETE, this.oid);
        HPEServices.publish(HPEConstants.catalog.COMPARE_LIST_REMOVE, this.oid);
    }
});

/**
 * Product Catalog Collection of Compare Tray Items
 */
module.exports = AmpersandCollection.extend({
    mainIndex: 'oid',
    model: CompareTrayItemModel,
    comparator: function(item) {
        return !item.oid;
    }
});
